export enum PlatformImportedCvAction {
  UNSET = 'unset',
  MAIN = 'main',
  CV = 'cv',
  COVER_LETTER = 'cover-letter',
  CERTIFICATE = 'certificate',
  OTHER = 'other',
  DISCARD = 'discard',
}
